import React from 'react';
import { Box, Typography } from '@mui/material';
import { useAuth } from 'contexts/AuthContext';
import TeamEmailSignatureContent from 'team/components/editMember/emailSignature/TeamEmailSignatureContent';

const TeamCreateEmailSignaturePreview = ({ 
    loading, 
    defaultCardId, 
    emailSignatureState,
    signatureRef,
    setLoading 
}) => {
    const { authState } = useAuth();
    const userEmail = authState?.user?.email;

    return (
        <Box sx={{
            width: '50%',
            overflowY: 'auto',
            padding: 4,
            backgroundColor: '#f7f7f7',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        }}>
            <Typography variant="body2" sx={{ fontSize: '0.7rem', fontWeight: 600, color: "#828282", mb: 3, textAlign: 'center' }}>
                Signature Preview
            </Typography>

            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                    <Typography variant="body2" color="text.secondary">Loading preview...</Typography>
                </Box>
            ) : defaultCardId ? (
                <>
                    <Box sx={{ 
                        boxShadow: 3, 
                        borderRadius: 2, 
                        overflow: 'hidden', 
                        width: '100%', 
                        maxWidth: { xs: '100%', sm: '400px', md: '450px' }
                    }}>
                        <TeamEmailSignatureContent
                            ref={signatureRef}
                            emailSignatureState={emailSignatureState}
                            cardId={defaultCardId}
                            setLoading={setLoading}
                            setError={() => { }}
                        />
                    </Box>
                    {userEmail && (
                        <Typography variant="body2" sx={{ 
                            fontSize: '0.7rem', 
                            color: "#828282", 
                            mt: 2, 
                            textAlign: 'center',
                            fontStyle: 'italic'
                        }}>
                            Preview based on {userEmail}
                        </Typography>
                    )}
                </>
            ) : (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                    <Typography variant="body2" color="text.secondary">No card found for preview</Typography>
                </Box>
            )}
        </Box>
    );
};

export default TeamCreateEmailSignaturePreview;

